import { map, isArray, set, last, extend, isFunction } from 'lodash';
export function createSlickDataSource(app, options) {
    const ds = datasourceFromString(app, options.name);
    return async function () {
        const r = await ds(options.parameters);
        if (r) {
            return onResultData(r, options);
        }
    };
}
function onResultData(data, options) {
    if (options.assignUniqueId && isArray(data)) {
        return map(data, (p, i) => set(p, 'id', i));
    }
    return data;
}
function datasourceFromString(app, dataSource) {
    const openapi = app.connections.getConnection('default');
    const operationId = last(dataSource.split('/'));
    return async function (params) {
        const result = await openapi.request(operationId, {
            parameters: extend({ skip: 0 }, resolveParams(params))
        });
        return isArray(result.data) ? result.data : result.data['data'];
    };
}
function resolveParams(params) {
    if (isFunction(params)) {
        return params();
    }
    return params;
}
//# sourceMappingURL=slickDataSource.js.map